import Button from 'components/form/Button.component';
import useIsFromMobileApp from 'hooks/useIsFromMobileApp.hook';
import { useTranslation } from 'providers/GILT.provider';
import { exportCSV } from 'utils/converters/csv.util';

import CN from './DownloadExcelButton.module.scss';

export const DownloadExcelButton = ({ getCsvData, fileName, disabled }) => {
  const { t } = useTranslation();
  const isFromMobile = useIsFromMobileApp();

  if (isFromMobile) return null;

  const handleClick = () => {
    const csvData = getCsvData?.();
    if (!csvData?.length) return;

    exportCSV({ data: csvData, fileName });
  };

  return (
    <Button variant="primaryForce" onClick={handleClick} disabled={disabled} width="small">
      <span className={CN.buttonText}>{t('composite.downloadExcelButton.downloadExcel')}</span>
    </Button>
  );
};
